"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STATE_UNDEFINED = exports.STATE_REQUESTED_BY_RECIPIENT = exports.STATE_REQUESTED_BY_ME = exports.STATE_DENIED_BY_RECIPIENT = exports.STATE_DENIED_BY_ME = exports.STATE_BLOCKED_BY_RECIPIENT = exports.STATE_BLOCKED_BY_ME = exports.STATE_ALLOWED = exports.PM_WINDOW_MINIMIZE_ALL = exports.PM_WINDOW_MINIMIZE = exports.PM_WINDOW_MAXIMIZE = exports.PM_USER_UPDATE = exports.PM_TYPING_NOTIFY = exports.PM_SESSION_START = exports.PM_SESSION_REVOKED = exports.PM_SESSION_HIDE = exports.PM_SESSION_DECLINED = exports.PM_SESSION_ACCEPTED = exports.PM_REQUEST_CANCELLED = exports.PM_PRELOGIN = exports.PM_PRECONNECT = exports.PM_OPEN_ATTACHMENT = exports.PM_MESSAGE = exports.PM_HISTORY = exports.PM_DISCONNECT = exports.PM_DELETE_HISTORY = exports.PM_CONVERSATION_LIST = exports.PM_CONVERSATION_CHANGED = exports.PM_CONVERSATIONS = exports.PM_CLOSE_ATTACHMENT = exports.PM_CLOSE = exports.PM_CLIENT_UPDATE = exports.PM_CLIENT_LOGOUT = exports.PM_CLIENT_LOGIN = exports.PM_CLEAR_TYPING_NOTIFY = exports.PM_ACTION_LOAD_MESSAGES_SUCCESS = exports.PM_ACCESS_UNDEFINED = exports.PM_ACCESS_RESET_REASON_REQUEST_CANCEL = exports.PM_ACCESS_REQUESTED_BY = exports.PM_ACCESS_REQUEST = exports.PM_ACCESS_NEGOTIATING = exports.PM_ACCESS_DENY = exports.PM_ACCESS_DENIED_BY_ME = exports.PM_ACCESS_DENIED_BY = exports.PM_ACCESS_CHANGE_UNDEFINED = exports.PM_ACCESS_CHANGE_DENIED = exports.PM_ACCESS_CHANGE_ALLOWED = exports.PM_ACCESS_ALLOW = void 0;
var PM_SESSION_START = 'PM_SESSION_START';
exports.PM_SESSION_START = PM_SESSION_START;
var PM_SESSION_HIDE = 'PM_SESSION_HIDE';
exports.PM_SESSION_HIDE = PM_SESSION_HIDE;
var PM_SESSION_ACCEPTED = 'PM_SESSION_ACCEPTED';
exports.PM_SESSION_ACCEPTED = PM_SESSION_ACCEPTED;
var PM_SESSION_DECLINED = 'PM_SESSION_DECLINED';
exports.PM_SESSION_DECLINED = PM_SESSION_DECLINED;
var PM_SESSION_REVOKED = 'PM_SESSION_REVOKED';
exports.PM_SESSION_REVOKED = PM_SESSION_REVOKED;
var PM_ACCESS_REQUEST = 'PM_ACCESS_REQUEST';
exports.PM_ACCESS_REQUEST = PM_ACCESS_REQUEST;
var PM_ACCESS_CHANGE_ALLOWED = 'PM_ACCESS_CHANGE_ALLOWED';
exports.PM_ACCESS_CHANGE_ALLOWED = PM_ACCESS_CHANGE_ALLOWED;
var PM_ACCESS_CHANGE_DENIED = 'PM_ACCESS_CHANGE_DENIED';
exports.PM_ACCESS_CHANGE_DENIED = PM_ACCESS_CHANGE_DENIED;
var PM_ACCESS_CHANGE_UNDEFINED = 'PM_ACCESS_CHANGE_UNDEFINED';
exports.PM_ACCESS_CHANGE_UNDEFINED = PM_ACCESS_CHANGE_UNDEFINED;
var PM_REQUEST_CANCELLED = 'PM_REQUEST_CANCELLED';
exports.PM_REQUEST_CANCELLED = PM_REQUEST_CANCELLED;
var PM_ACCESS_RESET_REASON_REQUEST_CANCEL = 'cancel';
exports.PM_ACCESS_RESET_REASON_REQUEST_CANCEL = PM_ACCESS_RESET_REASON_REQUEST_CANCEL;
var PM_MESSAGE = 'PM_MESSAGE';
exports.PM_MESSAGE = PM_MESSAGE;
var PM_HISTORY = 'PM_HISTORY';
exports.PM_HISTORY = PM_HISTORY;
var PM_TYPING_NOTIFY = 'PM_TYPING_NOTIFY';
exports.PM_TYPING_NOTIFY = PM_TYPING_NOTIFY;
var PM_CLEAR_TYPING_NOTIFY = 'PM_CLEAR_TYPING_NOTIFY';
exports.PM_CLEAR_TYPING_NOTIFY = PM_CLEAR_TYPING_NOTIFY;
var PM_DELETE_HISTORY = 'PM_DELETE_HISTORY';
exports.PM_DELETE_HISTORY = PM_DELETE_HISTORY;
var PM_ACCESS_ALLOW = 'allow';
exports.PM_ACCESS_ALLOW = PM_ACCESS_ALLOW;
var PM_ACCESS_DENY = 'deny';
exports.PM_ACCESS_DENY = PM_ACCESS_DENY;
var PM_ACCESS_DENIED_BY_ME = 'denied_by_me';
exports.PM_ACCESS_DENIED_BY_ME = PM_ACCESS_DENIED_BY_ME;
var PM_ACCESS_UNDEFINED = 'undefined';
exports.PM_ACCESS_UNDEFINED = PM_ACCESS_UNDEFINED;
var PM_ACCESS_NEGOTIATING = 'negotiating';
exports.PM_ACCESS_NEGOTIATING = PM_ACCESS_NEGOTIATING;
var PM_ACCESS_DENIED_BY = 'denied_by';
exports.PM_ACCESS_DENIED_BY = PM_ACCESS_DENIED_BY;
var PM_ACCESS_REQUESTED_BY = 'requested_by';
exports.PM_ACCESS_REQUESTED_BY = PM_ACCESS_REQUESTED_BY;
var PM_WINDOW_MINIMIZE = 'PM_WINDOW_MINIMIZE';
exports.PM_WINDOW_MINIMIZE = PM_WINDOW_MINIMIZE;
var PM_WINDOW_MAXIMIZE = 'PM_WINDOW_MAXIMIZE';
exports.PM_WINDOW_MAXIMIZE = PM_WINDOW_MAXIMIZE;
var PM_WINDOW_MINIMIZE_ALL = 'PM_WINDOW_MINIMIZE_ALL';
exports.PM_WINDOW_MINIMIZE_ALL = PM_WINDOW_MINIMIZE_ALL;
var PM_CONVERSATION_LIST = 'PM_CONVERSATION_LIST';
exports.PM_CONVERSATION_LIST = PM_CONVERSATION_LIST;
var PM_CONVERSATIONS = 'PM_CONVERSATIONS';
exports.PM_CONVERSATIONS = PM_CONVERSATIONS;
var PM_CONVERSATION_CHANGED = 'PM_CONVERSATION_CHANGED';
exports.PM_CONVERSATION_CHANGED = PM_CONVERSATION_CHANGED;
var PM_CLIENT_LOGIN = 'PM_CLIENT_LOGIN';
exports.PM_CLIENT_LOGIN = PM_CLIENT_LOGIN;
var PM_CLIENT_LOGOUT = 'PM_CLIENT_LOGOUT';
exports.PM_CLIENT_LOGOUT = PM_CLIENT_LOGOUT;
var PM_CLIENT_UPDATE = 'PM_CLIENT_UPDATE';
exports.PM_CLIENT_UPDATE = PM_CLIENT_UPDATE;
var PM_USER_UPDATE = 'PM_USER_UPDATE';
exports.PM_USER_UPDATE = PM_USER_UPDATE;
var PM_CLOSE = 'PM_CLOSE';
exports.PM_CLOSE = PM_CLOSE;
var PM_PRECONNECT = 'PM_PRECONNECT';
exports.PM_PRECONNECT = PM_PRECONNECT;
var PM_DISCONNECT = 'PM_DISCONNECT';
exports.PM_DISCONNECT = PM_DISCONNECT;
var PM_PRELOGIN = 'PM_PRELOGIN';
exports.PM_PRELOGIN = PM_PRELOGIN;
var STATE_UNDEFINED = 'undefined';
exports.STATE_UNDEFINED = STATE_UNDEFINED;
var STATE_REQUESTED_BY_RECIPIENT = 'requested_by_recipient';
exports.STATE_REQUESTED_BY_RECIPIENT = STATE_REQUESTED_BY_RECIPIENT;
var STATE_REQUESTED_BY_ME = 'requested_by_me';
exports.STATE_REQUESTED_BY_ME = STATE_REQUESTED_BY_ME;
var STATE_DENIED_BY_RECIPIENT = 'denied_by_recipient';
exports.STATE_DENIED_BY_RECIPIENT = STATE_DENIED_BY_RECIPIENT;
var STATE_DENIED_BY_ME = 'denied_by_me';
exports.STATE_DENIED_BY_ME = STATE_DENIED_BY_ME;
var STATE_BLOCKED_BY_RECIPIENT = 'blocked_by_recipient';
exports.STATE_BLOCKED_BY_RECIPIENT = STATE_BLOCKED_BY_RECIPIENT;
var STATE_BLOCKED_BY_ME = 'blocked_by_me';
exports.STATE_BLOCKED_BY_ME = STATE_BLOCKED_BY_ME;
var STATE_ALLOWED = 'allowed';
exports.STATE_ALLOWED = STATE_ALLOWED;
var PM_CLOSE_ATTACHMENT = 'PM_CLOSE_ATTACHMENT';
exports.PM_CLOSE_ATTACHMENT = PM_CLOSE_ATTACHMENT;
var PM_OPEN_ATTACHMENT = 'PM_OPEN_ATTACHMENT';
exports.PM_OPEN_ATTACHMENT = PM_OPEN_ATTACHMENT;
var PM_ACTION_LOAD_MESSAGES_SUCCESS = 'PM_ACTION_LOAD_MESSAGES_SUCCESS';
exports.PM_ACTION_LOAD_MESSAGES_SUCCESS = PM_ACTION_LOAD_MESSAGES_SUCCESS;